var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { TextInput, DialogHeader, DialogContent, DialogFooter, Alert, useToast, Box } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Field } from 'formik';
import { object, string } from 'yup';
import { useRenameEntry } from 'app/domains/filesystem';
import { CancelButton, FormDialog, SubmitButton } from 'shared/domains/forms';
const Schema = object().shape({
    name: string().trim().required(),
});
export function RenameEntryDialog(props) {
    const { onRenamed, type, payload, onClose } = props;
    const { addToast } = useToast();
    const [renameEntry, mutation] = useRenameEntry({ type, id: payload.id, onRenamed });
    const initialValues = { name: payload.name };
    const handleSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield renameEntry(values.name);
            onClose();
        }
        catch (_a) {
            addToast({
                title: t({
                    message: 'Something went wrong, please try again later.',
                    comment: 'Rename document/folder dialog error toast',
                }),
                appearance: 'danger',
            });
        }
    });
    return (<FormDialog size="sm" onClose={onClose} onSubmit={handleSubmit} validationSchema={Schema} initialValues={initialValues}>
      <DialogHeader title={t({
            message: 'Edit name',
            comment: 'Rename document/folder dialog title',
        })} icon={<Falcon icon="pen"/>}/>
      <DialogContent>
        <Box flexDirection="column" gap="lg">
          <Field stretch name="name" as={TextInput} label={t({ message: 'Document name', comment: 'Rename document dialog - Document name input label' })} placeholder={t({
            message: 'Document name...',
            comment: 'Rename document dialog - Document name input placeholder',
        })}/>
          {mutation.error && (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please try again later',
                comment: 'Error alert message',
            })}/>)}
        </Box>
      </DialogContent>
      <DialogFooter>
        <CancelButton size="small" appearance="secondary" onClick={onClose}>
          <Trans>Cancel</Trans>
        </CancelButton>
        <SubmitButton size="small" appearance="primary">
          <Trans>Rename</Trans>
        </SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
